<template>
    <template v-if="mergedGallery.length">
        <Fancybox ref="fancybox" :fancybox-options="{ groupAll: true }" class="grid grid-cols-4 grid-rows-2 gap-1 md:gap-3 *:first:col-span-2 *:first:row-span-2 rounded-lg overflow-hidden">
            <template v-for="(media, idx) in mergedGallery" :key="media.id ?? media.url ?? idx">
                <a :href="media.full || media.url" data-fancybox="gallery" class="block w-full h-full" :class="idx >= 5 ? 'hidden' : ''" :aria-label="`Open image ${idx + 1} of ${mergedGallery.length}`">
                    <img :src="media.url" class="w-full h-full object-cover aspect-square" :alt="media.alt" loading="lazy" decoding="async" />
                </a>
            </template>
        </Fancybox>

        <button type="button" class="absolute bottom-2 md:bottom-4 right-2 md:right-4 btn btn-default btn-md" @click="openGallery">
            <i class="icon-drag order-first"></i>
            {{ $t('Open gallery') }}
        </button>
    </template>
</template>

<script setup>
const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
})

const mergedGallery = computed(() => {
    const product = (props.item.gallery ?? []).map((m, idx) => ({
        ...m,
        source: 'product',
        alt: m.alt || `Photo ${idx + 1} — ${props.item.name || 'Product'}`,
    }))

    const loc = (props.item.property?.gallery ?? []).map((m, idx) => ({
        ...m,
        source: 'property',
        alt: m.alt || `Property photo ${idx + 1} — ${props.item.property?.label || props.item.name || 'Property'}`,
    }))

    // ✅ combine product first, then property
    return [...product, ...loc]
})

function openGallery() {
    // open first Fancybox item
    document.querySelector('[data-fancybox="gallery"]')?.click()
}
</script>
